import React, {useContext, useEffect, useState} from "react";
import {Title} from "../../../../../../stories/Title/Title";
import RightArrow from "../../../../../../images/ArrowRight.svg";
import Close from "../../../../../../images/Close.svg";
import Legends from "../../../maps/ticketing/junctionDetails/Legends";
import {Button} from "../../../../../../stories/Button/Button";
import {AppContext} from "../../../../../../context/context";
import {CustomDrawer} from "../../../../../../styles/CustomDrawerStyles";
import ViewAssetDetails from "../../../maps/ticketing/raisedtickets/ViewAssetDetails";
import ItemsAutocomplete from "../../../../../../customComponents/ItemsAutocomplete";
import useLabels from "../../../../../../customHooks/useLabels";
import {
  debouncedDelay,
  EMPTY_STRING,
  emptyFunc,
  FETCH_MORE_DATA,
  TicketStatus,
} from "../../../../../../utils/constants";
import Input from "../../../../../../stories/Input/Input";
import {useLazyQuery} from "@apollo/client";
import {
  GetItemsDetailsForDashboard,
  JunctionsNode,
} from "../../../masters/items/queries/queries";
import {
  nodeVar,
  OrderDirection,
} from "../../../../../../utils/commonQueryTypes";
import {Junction} from "../../../masters/subsidary/junctions/queries/types";

import JunctionDetails from "./JunctionDetails";
import {payloadTypes} from "../../../../../../context/reducer";
import {
  AtsStckItemDetailsEdges,
  AtsStckItemDetailsOrderField,
  GetItemsDetailsResult,
  GetItemsDetailsVars,
} from "../../../masters/items/queries/types";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import {ItemDetailsQueryType} from "../../../../../../utils/Enum.types";
import {getModifiedScrollHeight} from "../../../../../../utils/UtilFunctions";
import PoleNumComponent from "../../../../../common/Autocomplete/PoleNumComponent";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { useDebounce } from "../../../../../../customHooks/useDebounce";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const JunctionWiseAsset = ({setModalFlag}: Props) => {
  const [assetDetailsModal, setAssetDetailsModal] = useState(false);
  const {state, dispatch} = useContext(AppContext);

  const {itemLabel} = useLabels();
  const {user_details} = useLoggedInUserDetails();
  const {customer_id} = useUrlParams();
  const [searchData, setSearchData] = useState("");
  const debouncedSearch = useDebounce(searchData, debouncedDelay);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);

  const [items, setItems] = useState<AtsStckItemDetailsEdges[]>([]);

  const [poleNum, setPoleNum] = useState(0);

  const [GetItemsDetails, {data, loading, fetchMore}] = useLazyQuery<
    GetItemsDetailsResult,
    GetItemsDetailsVars
  >(GetItemsDetailsForDashboard);

  useEffect(() => {
    if (customer_id) {
      GetItemsDetails({
        variables: {
          customerID: customer_id ? customer_id : 0,
          companyID: 0,
          subsidiaryID: 0,
          junctionID: state.junctionID ? state.junctionID : 0,
          siteID: 0,
          input: {
            query_type: state.itmId
              ? ItemDetailsQueryType.DETAILS_BY_ITEM_ID
              : ItemDetailsQueryType.ALL,
            stckCategoryID: 0,
            stckGroupID: 0,
            stckManufacturerID: 0,
            stckUomID: 0,
            stckSubCategoryID: 0,
            itemID: state.itmId ? state.itmId : 0,
            ldgrID: 0,
            poleNum,
            empID: user_details.id,
          },
          after: null,
          first: 10,
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsStckItemDetailsOrderField.CREATED_AT,
          },
          name: debouncedSearch,
        },
      });
    }
  }, [
    GetItemsDetails,
    state.junctionID,
    customer_id,
    state.itmId,
    poleNum,
    debouncedSearch,
  ]);

  const handleScroll = (e: React.UIEvent<HTMLDivElement, UIEvent>) => {
    const target = e.target as HTMLDivElement;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
      if (hasNextPage && !loading) {
        fetchMore({
          variables: {
            first: FETCH_MORE_DATA,
            after: endCursor,
          },
          updateQuery: (prevResult, {fetchMoreResult}) => {
            if (!fetchMoreResult) return prevResult;

            const newEdges = fetchMoreResult.GetItemsDetails.edges;
            const pageInfo = fetchMoreResult.GetItemsDetails.pageInfo;
            setEndCursor(pageInfo.endCursor);
            setHasNextPage(pageInfo.hasNextPage);

            const duplicateCheck = prevResult.GetItemsDetails.edges.filter(
              ({node: {id}}) =>
                newEdges.findIndex(({node: {id: newId}}) => newId === id) !== -1
            );

            if (duplicateCheck.length > 0) return prevResult;

            return {
              GetItemsDetails: {
                edges: [...items, ...newEdges],
                pageInfo,
                totalCount: data ? data.GetItemsDetails.totalCount! : 0,
              },
            };
          },
        });
      }
    }
  };

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetItemsDetails.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = items.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setItems(updatedNewData);
      } else {
        setItems(newData);
      }
      setEndCursor(data.GetItemsDetails.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  const [getJunctionByNode, {data: junctionData}] = useLazyQuery<
    {node: Junction},
    nodeVar
  >(JunctionsNode);

  useEffect(() => {
    if (state.junctionID) {
      getJunctionByNode({
        variables: {
          id: state.junctionID,
        },
      });
    }
  }, [getJunctionByNode, state.junctionID]);

  useEffect(() => {
    dispatch({
      type: payloadTypes.SET_ITEM_ID,
      payload: {
        itmId: 0,
      },
    });
    setPoleNum(0);
  }, []);

  return (
    <div className="d-junc-wise-asset">
      <div className="d-junc-wise-asset__title">
        <Title>{junctionData ? junctionData.node.name : EMPTY_STRING}</Title>
        <img src={Close} alt="" onClick={() => setModalFlag(false)} />
      </div>
      <div className="d-signal-complete-details--h">
        <JunctionDetails />
      </div>
      <div className="d-junc-wise-asset__filters row g-2">
        <div className="col-3">
          <ItemsAutocomplete
            onChange={(newValue) => {
              if (newValue) {
                dispatch({
                  type: payloadTypes.SET_ITEM_ID,
                  payload: {
                    itmId: newValue.value,
                  },
                });
              } else {
                dispatch({
                  type: payloadTypes.SET_ITEM_ID,
                  payload: {
                    itmId: 0,
                  },
                });
              }
            }}
            onKeyDown={emptyFunc}
            value={state.itmId}
            label={itemLabel}
            placeholder=""
            isComponent={true}
          />
        </div>{" "}
        <div className="col-3">
          {junctionData && junctionData.node.poles > 0 ? (
            <PoleNumComponent
              onChange={(newValue) => {
                setPoleNum(newValue);
              }}
              onKeyDown={emptyFunc}
              value={poleNum}
              label="Pole Number"
              poleNum={junctionData ? junctionData.node.poles : 0}
            />
          ) : null}
        </div>
      </div>
      <Input
        id="data_search"
        placeholder="Search..."
        onChange={(e) => {
          setSearchData(e.target.value);
        }}
      />

      <div className="d-junc-wise-asset__ul" onScroll={handleScroll}>
        {data ? (
          <ul>
            {items.map(({node}, index) => {
              const img = require(`../../../../../../images/ItemIcons/${
                node.item.icon ? node.item.icon : "item"
              }.svg`);
              return (
                <li
                  key={index}
                  onClick={() => {
                    dispatch({
                      type: payloadTypes.SET_ITEM_DETAILS_ID,
                      payload: {
                        itemDetailsId: node.id,
                      },
                    });
                    setAssetDetailsModal(!assetDetailsModal);
                  }}
                >
                  <div className="d-junc-wise-asset__ul--flex">
                    {index + 1}. <img src={img} alt="" />
                    <div>
                      <b
                        className={
                          node.ticketStatus === TicketStatus.OPEN
                            ? "font-red"
                            : ""
                        }
                      >
                        {node.item.desc}
                      </b>
                      <span className="font-blue">{node.prodSerialNo}</span>
                    </div>
                  </div>
                  <img
                    src={RightArrow}
                    alt=""
                    className="d-signal-complete-details--image"
                  />
                </li>
              );
            })}
          </ul>
        ) : null}
      </div>
      <div className="row g-0">
        <div className="col">
          <Button mode="cancel" onClick={() => setModalFlag(false)} />
        </div>
        <div className="col flex-end">
          <Legends />
        </div>
      </div>
      <CustomDrawer
        anchor="right"
        open={assetDetailsModal}
        onClose={() => setAssetDetailsModal(!assetDetailsModal)}
      >
        <ViewAssetDetails
          setModalFlag={setAssetDetailsModal}
          itemId={state.itemDetailsId}
        />
      </CustomDrawer>
    </div>
  );
};

export default JunctionWiseAsset;
